import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {FixHandwritingView} from "../views/fix_handwriting";
import {CardPrintView} from "../views/cardprint";

export class FixHandwritingFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new FixHandwritingView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/handwriting/fix`;
    }

}

export class CardPrintFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new CardPrintView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/cardprint`;
    }

}
